import React, { useEffect } from "react"
import { Avatar, Grid, IconButton } from "@mui/material"
import { useHookstate, type State } from "@hookstate/core"
import FilterAutocompleteFetch from "~/components/FilterAutocompleteFetch"
import { useLang } from "~/hooks/useLang"
import { parseMaterialDetail, type ItemMaterialCheckout, type RawMaterialDetail } from "../../../interface"
import FilterTextField from "~/components/FilterTextField"
import { Remove } from "@mui/icons-material"

interface MaterialsRowProps {
  readonly item: State<ItemMaterialCheckout>;
  readonly position: number;
  readonly disabledRemoveItem?: boolean;
  readonly warehouseId: State<number | null>;
  readonly onRemove: () => void;
}

export default function MaterialsRow({ item, position, disabledRemoveItem, warehouseId, onRemove }: MaterialsRowProps) {
  const { translate } = useLang();
  const rawMaterial = useHookstate<RawMaterialDetail | null>(null)
  const rawMaterialValue = rawMaterial.get()
  const rawMaterialId = rawMaterialValue?.id ?? null

  useEffect(() => {
    if (rawMaterialValue) {
      const parsed = parseMaterialDetail(rawMaterialValue)
      item.merge({
        itemId: parsed.id,
        groupId: parsed.materialGroupId,
        material: parsed,
      })
    } else {
      item.merge({ itemId: null, groupId: null, material: null })
    }
  }, [rawMaterialId])

  return (
    <>
      <Grid item xs={3}>
        <FilterAutocompleteFetch
          label={translate('Materials')}
          urlFetch={'/warehouse-material/all-for-logged-user'}
          dataRequest={'material'}
          paramsPayload={{ warehouse_id: warehouseId.get() }}
          size={'small'}
          onFetchChange={(id: number | null) => item.itemId.set(id)}
          disabled={!warehouseId.get()}
          getFullObject={rawMaterial}
          valueId={item.itemId.get() ?? undefined}
        />
      </Grid>
      <Grid item xs={3}>
        <FilterTextField
          label={translate('Equipment Group')}
          type="text"
          disabled
          currentText={item.material.get()?.materialGroup.name ?? ''}
          onTextFieldChange={(val) => item.quantity.set(Number(val))}
        />
      </Grid>
      <Grid item xs={2}>
        <FilterTextField
          label={translate('Quantity')}
          type="number"
          disabled={!item.material.get()}
          currentText={item.material.get()?.totalInventory !== null ? String(item.material.get()?.totalInventory) : ''}
          onTextFieldChange={(val) => item.material['totalInventory'].set(Number(val))}
        />
      </Grid>
      {(!disabledRemoveItem || position > 0) &&
        <Grid item xs={1}>
          <Avatar
            onClick={onRemove}
            sx={{
              width: 24,
              height: 24,
              cursor: 'pointer',
              backgroundColor: 'primary.main'
            }}
          >
            <Remove />
          </Avatar>
        </Grid>
      }
    </>
  )
}
